import config from "@/config/config";

import Index from "@/pages/faq/index.vue";
import List from "@/pages/faq/list/list.vue";
import View from "@/pages/faq/view/view.vue";
import New from "@/pages/faq/new/new.vue";
import Edit from "@/pages/faq/edit/edit.vue";

const modulePermission = config.modules.faq;

export default {
  path: "/faq",
  name: "faq",
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: "enabled_read",
  },
  children: [
    {
      path: "list",
      name: "faq-list",
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
    },
    {
      path: ":id",
      name: "faq-view",
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
      props: true,
    },
    {
      path: "new",
      name: "faq-new",
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_create",
      },
    },
    {
      path: ":id/e",
      name: "faq-edit",
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_edit",
      },
      props: true,
    },
  ],
};
